import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

export default function createStore () {
  return new Vuex.Store({
    modules: {
      // The settings for the running application
      app
    }
  })
}
